<template>
    <b-row>
        <b-col cols="9">
            <b-row>
                <b-col class="workspace-header">
                    <h1 class="text-right"><i class="fa-solid fa-share fa-fw"></i> Returns</h1>
                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <transition appear name="fade" mode="out-in">
                        <router-view></router-view>
                    </transition>
                </b-col>
            </b-row>
        </b-col>

        <b-col cols="3">
            <b-row>
                <b-col>
                    <dashboard-side-data-widget dual dualLink
                                                label="To Pull"
                                                label2="To Pull - Split"
                                                :data="dashboardData.totalFullReturns"
                                                :data2="dashboardData.totalSplitReturns"
                                                clickable
                                                to="/inventory/returns/full"
                                                to2="/inventory/returns/split-kit"
                    ></dashboard-side-data-widget>


                    <dashboard-side-data-widget label="To Pull - Full" :data="dashboardData.totalOutstandingReturns"
                                                icon="fa-light fa-undo"
                                                clickable
                                                to="/inventory"

                    ></dashboard-side-data-widget>

                    <dashboard-side-data-widget label="Completed" :data="dashboardData.totalCompletedReturns"
                                                icon="fa-light fa-box-circle-check"
                                                clickable
                                                to="/search?filterField_0=status_id&filterModel_0=order&filterName_0=Order%20Status&filterParameter_0=equals&filterValue_0=12"
                    ></dashboard-side-data-widget>

                    <b-button block @click="createReverseShipment">Create Reverse Shipment (TEST)</b-button>

                </b-col>
            </b-row>
        </b-col>

    </b-row>
</template>

<script>
    import {
        BROADCAST_CONNECTED,
    } from '../../store/actions';
    import DashboardSideDataWidget from '@/components/DashboardSideDataWidget';
    import {assign} from 'lodash';

    export default {
        name: 'returns-index',
        title: 'Returns',
        components: {DashboardSideDataWidget},
        data() {
            return {
                dashboardData: {
                    totalFullReturns: null,
                    totalSplitReturns: null,
                    totalOutstandingReturns: null,
                    totalCompletedReturns: null,
                },
            };
        },
        created() {

        },
        mounted() {
            this.getDashboardData();

            console.info(String.fromCodePoint(0x1F6F0) + '%c Broadcast Connected:', 'color:yellow;', this.$store.getters.isBroadcastConnected);
            if (! this.$store.getters.isBroadcastConnected) {
                this.$store.subscribe((mutation) => {
                    console.log('%cSubscribe mutation ' + mutation.type, 'color:gray;');
                    if (mutation.type === BROADCAST_CONNECTED) {
                        console.info(String.fromCodePoint(0x1F504) + '%c Joining via BROADCAST_CONNECTED mutation.', 'color:green;');
                        this.joinBroadcastChannel();
                    }
                });
            } else {
                console.info(String.fromCodePoint(0x2757) + '%c Joining via isBroadcastConnected getter.', 'color:teal;');
                this.joinBroadcastChannel();
            }
            // this.$barcodeScanner.init(rawBarcode => {
            //     this.$barcodeScanner.parseBarcode(rawBarcode, (barcode, context) => {
            //         if(this.$route.params.id == barcode) {
            //             this.$parent.$bvModal.msgBoxOk("Order " + barcode + " is already loaded!", {
            //                 title: "Order already loaded",
            //                 size: 'md',
            //                 buttonSize: 'sm',
            //                 okVariant: 'danger',
            //                 headerClass: 'p-2 border-bottom-0 text-center d-block',
            //                 footerClass: 'p-2 border-top-0',
            //             });
            //             return;
            //         }
            //         if (context === 'O' || context === 'R') {
            //             this.$router.push({path: '/returns/view/' + encodeURIComponent(barcode)});
            //         } else {
            //             this.$http.get('/reverse-shipments/scan/' + barcode)
            //                 .then(response => {
            //                     if (response.data.id) {
            //                         this.$router.push({path: '/returns/view/' + response.data.id});
            //                     }
            //                 });
            //         }
            //     });
            // });
        },
        beforeDestroy() {
            console.info(String.fromCodePoint(0x1F44B) + ' Leaving App.Returns channel from Returns/index.vue.');
            this.$echo.leaveChannel('App.Returns');
            // this.$barcodeScanner.destroy();
        },
        methods: {
            joinBroadcastChannel: function () {
                console.info(String.fromCodePoint(0x1F91D) + ' Joining App.Returns channel from Returns/index.vue.');
                this.$echo.channel('App.Returns')
                    .listen('BroadcastDashboardUpdate', (e) => {
                        this.dashboardData = assign(this.dashboardData, e.payload);
                    });
            },

            getDashboardData() {
                this.$http.get('/dashboards/returns')
                    .then(response => {
                        this.dashboardData = assign(this.dashboardData, response.data.data);
                    });
            },

            createReverseShipment() {
                this.$http.post('/orders/2/reverse-shipments')
                .then(response => {
                    console.log(response);
                });
            }
        }
    };
</script>

<style scoped>

</style>
